import React from 'react'
import Text from '@component/Text/Text'

export const PrivacyTermKorean = () => {
    return (
        <>
            <div className={'text-body1 text-gray02 dark:text-dark_gray02 px-[30px]'}>
                <Text className={'text-h2 text-gray01 dark:text-dark_gray01'}>League of Traders</Text>
                <Text className={'mt-[10px]'}>
                    주식회사 위즈페이스(이하 회사)는 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’ 및
                    ‘개인정보보호법’ 등 관계법률에 근거하여 정보통신서비스제공자가 준수하여야 할 관련 법령상의
                    개인정보보호 규정을 준수하고, 개인정보 처리방침을 마련하여 회원의 권익보호에 최선을 다하고 있습니다.
                    <br />
                    개인정보 처리방침은 개인정보와 관련한 법령 또는 지침의 변경이 있는 경우, 회사의 정책이 변동되는 경우
                    변경될 수 있으나 변경된 내용에 대해서는 회원 여러분에게 지체없이 통지하고 수시로 확인할 수 있도록
                    [홈페이지 첫 화면]에 공지하여 게시하겠습니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    회사의 리그오브트레이더스(이하 ‘서비스’)와 관련한 개인정보 처리방침은 다음과 같은 내용을 담고
                    있습니다.
                </Text>
                <div className={'pl-[20px] mt-[10px]'}>
                    개인정보 수집 이용 / 보유 / 파기
                    <br />
                    개인정보의 제 3 자 제공
                    <br />
                    개인정보의 처리위탁
                    <br />
                    개인정보의 파기절차 및 방법
                    <br />
                    회원의 권리와 그 행사 방법
                    <br />
                    회원의 의무
                    <br />
                    개인정보 자동 수집 설치 / 운영 및 거부에 관한 내용
                    <br />
                    개인정보 보호책임자 및 담당자의 연락처
                    <br />
                    고지의 의무
                    <br />
                </div>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    1. 개인정보 수집 이용 / 보유 / 파기
                </Text>
                <Text className={'mt-[10px]'}>
                    회사는 서비스를 제공하는데 필요한 최소한의 범위 내에서 회원의 개인정보를 수집하며, 수집하는 정보는
                    회원의 동의를 받은 범위 내에서만 사용합니다. 회사는 그 외 사전 동의 없이 회원의 개인정보를 동의를
                    받은 범위를 초과하여 이용하거나 외부에 공개하지 않습니다.
                    <br />
                </Text>
                <Text className={'mt-[10px]'}>
                    회사는 제공하는 서비스에 따라 다음과 같은 회원의 개인정보를 수집 및 이용하고 있습니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    필수정보 : 전화번호 또는 이메일
                    <br />
                    선택정보 : 이름, 소셜ID(카카오, 페이스북, 구글), 닉네임
                </Text>
                <Text className={'text-ti1 mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>회원</Text>
                <Text className={'mt-[10px]'}>
                    회사는 최초 회원 가입시 서비스의 본질적 기능을 수행하기 위해 필요한 최소한의 정보만을
                    &apos;필수정보&apos;로 정의하여 수집하고 있습니다. 또한, 회사가 제공하는 서비스의 성격에 따라 추가로
                    정보 수집이 필요할 경우 별도 동의를 얻고 추가적인 정보를 수집하며 (아래 &quot;추가정보&quot;),
                    선택정보는 입력하지 않아도 서비스 이용에 제한이 없습니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>수집방법</Text>
                <Text className={'mt-[10px]'}>홈페이지, 모바일 어플리케이션, 서면, 전화 등을 통해 수집</Text>
                <Text className={'text-ti1 mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    장기 미이용회원
                </Text>
                <Text className={'mt-[10px]'}>
                    장기 미이용회원은 서비스를 최종 이용 후 1 년 동안 이용 기록이 없는 회원을 지칭합니다.
                    <br />
                    장기 미이용회원의 개인정보는 미이용 1 년이 되는 시점에 회사가 별도로 분리 보관하며, 분리 보관된
                    개인정보는 4년간 보관 후 지체없이 파기(다만, 다른 법령에 따라 보관하여야 하는 정보는 다른 법령에서
                    정한 바에 따라 보관됩니다)합니다. 파기 전 회사는 최소 30 일 이전에 대상자에게 이메일 또는
                    문자메세지로 안내합니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    문자메세지 안내는 발송 시점까지 확인된 회원정보의 이메일 주소 또는 휴대전화번호를 통하여
                    이루어지므로, 이를 위해 회원은 최신의 연락처 정보를 업데이트 해두어야 합니다.
                    <br />
                    서비스를 지속적으로 이용하고자 하는 장기 미이용회원의 경우, 개인정보 파기 전 서비스에 로그인 해야
                    합니다.
                    <br />
                    (정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 29 조에 따름)
                </Text>
                <Text className={'text-ti1 mt-[10px] font-normal text-gray01 dark:text-dark_gray01'}>
                    이동통신단말장치의 접근권한
                </Text>
                <Text className={'mt-[10px]'}>
                    회원이 서비스를 편리하게 사용할 수 있도록 추가기능을 제공하기 위해, 서비스를 이용하는
                    이동통신단말장치에 대한 아래와 같이 몇 가지 접근권한을 요청합니다. (Android OS 를 사용하는
                    이동통신단말장치에 한함)
                    <br />
                    회원은 해당 권한에 대해 동의하지 않을 수 있으며 동의하지 않더라도 서비스를 이용하는데 제한이
                    없습니다. 또한 이동통신단말장치에서 서비스 어플리케이션을 삭제할 경우 동시에 해당 접근권한도
                    상실됩니다.
                    <br />
                    (정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 22 조의 2 에 따름)
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>2. 개인정보 제 3 자 제공</Text>
                <Text className={'mt-[10px]'}>
                    회사가 서비스 제공의 목적 또는 법령에 정해진 책임의 준수를 위해 보관하고 있는 회원의 개인정보는
                    회원이 동의하는 경우 제 3 자에게 개인정보 수집 목적 범위내에서 제공될 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>3. 개인정보 처리 위탁</Text>
                <Text className={'mt-[10px]'}>
                    회사는 서비스 향상과 효과적인 업무처리를 위하여 다음과 같이 개인정보를 처리 위탁할 수 있습니다.
                    회사는 수탁자들이 위탁한 개인정보를 안전하게 처리하고 있는지 지속적으로 관리 감독하고 있으며,
                    수탁업무가 종료된 때에 수탁자가 보유하고 있는 개인정보는 즉시 파기하게 하고 있습니다. 단, 현재
                    서비스 단계에서는 개인정보 위탁 처리가 필요하지 않아 이에 대한 동의를 요청하지 않습니다. 추후
                    개인정보 위탁 처리가 필요할 경우, 본 개인정보처리방침을 개정하고 개인정보를 수탁받는 자와 외탁
                    업무내용 및 개인정보 보유 및 이용기간을 명시하여 회원의 사전 동의를 받도록 하겠습니다.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    4. 개인정보의 파기절차 및 방법
                </Text>
                <Text className={'mt-[10px]'}>
                    회사는 원칙적으로 수집한 개인정보에 대해 이용 목적이 달성된 후, 즉시 해당 개인정보를 파기하고
                    있습니다. 개인정보의 파기 절차, 기한 및 방법은 다음과 같습니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    파기 절차 : 회원정보의 이용목적이 달성된 후 지체없이 삭제함.
                    <br />
                    파기 기한 : 탈퇴 신청 즉시(단, 유료결제 고객은 5년간 보유)
                    <br />
                    파기 방법 : 복구가 불가능한 방법으로 영구히 파기.(파일 및 데이터는 영구 삭제하며 종이 등 출력물은
                    파쇄기를 통한 파쇄)
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    5. 회원의 권리와 그 행사방법
                </Text>
                <Text className={'mt-[10px]'}>
                    회원 및 법정대리인은 언제든지 회사가 처리하고 있는 개인정보에 대하여 열람, 수정, 동의철회, 삭제 등을
                    요청할 수 있으며, 계정삭제를 요청할 수도 있습니다. 다만 개인정보 수집, 처리에 대한 동의 철회 또는
                    계정삭제시 서비스의 일부 또는 전체 이용이 제한될 수 있습니다.
                    <br />
                    회원이 개인정보의 오류에 대한 정정을 요청할 경우, 회사는 해당 개인정보의 오류를 정정하기 전까지
                    개인정보를 이용 또는 제공하지 않습니다. 또한, 잘못된 개인정보를 제 3 자에게 제공한 경우 회원의
                    요청으로 정정된 개인정보를 제 3 자에게 지체없이 통지하여 해당 개인정보의 정정이 이루어지도록
                    조치하겠습니다.
                    <br />
                    회사는 회원 혹은 법정 대리인의 요청에 의해 서비스 이용계약 해지 또는 계정삭제를 요청받은 개인정보를
                    &apos; 개인정보의 보유 및 이용기간&apos; 에 명시된 바에 따라 처리하고 그 외의 용도로 열람하거나
                    이용할 수 없도록 처리하고 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>6. 회원의 의무</Text>
                <Text className={'mt-[10px]'}>
                    회원은 정보주체로서 자신의 개인정보를 보호할 의무가 있으며, 로그인 정보의 양도<em>대여</em>분실이나
                    로그인 상태에서 이석 등 회원 본인의 부주의로 발생한 개인정보 유출에 대해서 회사가 책임지지 않음을
                    숙지해야 합니다.
                    <br />
                    회원은 자신의 개인정보를 최신의 상태로 유지하여 부정확한 정보 입력으로 인한 문제가 발생하지 않도록
                    관리할 의무가 있으며, 부정확한 정보 입력으로 문제가 발생할 경우, 이에 대한 책임은 회원이 부담합니다.
                    또한 타인의 개인정보를 도용한 회원가입, 서비스 이용 시 회원자격 상실과 함께 관련 법에 의거하여
                    처벌될 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    7. 개인정보 자동 수집 설치 / 운영 및 거부에 관한 내용
                </Text>
                <Text className={'mt-[10px]'}>
                    회사는 회원에게 더 편리한 서비스를 제공하기 위해 몇 가지 방법을 통해 회원 행태에 관한 정보 또는
                    비식별 데이터를 수집해 분석하고 있습니다. 이와 같은 정보 및 데이터의 제공을 원치 않으시면 언제든지
                    제공을 거부할 수 있습니다.
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    8. 개인정보 보호책임자 및 담당자의 연락처
                </Text>
                <Text className={'mt-[10px]'}>
                    회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 회사는 개인정보 보호책임자를
                    두고 있습니다. 회원의 개인정보와 관련한 문의 사항이 있으시면 아래의 개인정보 보호책임자 또는
                    개인정보 민원처리 담당부서에 연락 주시기 바랍니다.
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>개인정보보호책임자</Text>
                <Text className={'mt-[10px]'}>
                    · 이름 : 조민규
                    <br />
                    · 소속 : 본사
                    <br />
                    · 직위 : 대표이사
                    <br />· 메일 : <a href="mailto:minkyu.cho@wizpace.com">minkyu.cho@wizpace.com</a>
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>개인정보민원처리담당부서</Text>
                <Text className={'mt-[10px]'}>
                    · 부서 : 고객지원
                    <br />· 메일 : <a href="mailto:support@leagueoftraders.io">support@leagueoftraders.io</a>
                </Text>
                <Text className={'text-ti1 mt-[10px] text-gray01 dark:text-dark_gray01'}>
                    기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    · 개인정보 침해신고센터 : (국번없이) 118 (
                    <a href="http://privacy.kisa.or.kr">http://privacy.kisa.or.kr</a>)<br />· 개인정보 분쟁조정위원회 :
                    02-2100-2499 (<a href="http://kopico.go.kr">http://kopico.go.kr</a>)<br />· 대검찰청 사이버수사과 :
                    (국번없이) 1301 (<a href="http://spo.go.kr">http://spo.go.kr</a>)<br />· 경찰청 사이버안전국 :
                    (국번없이) 182 (<a href="http://cyberbureau.police.go.kr">http://cyberbureau.police.go.kr</a>)
                </Text>
                <Text className={'text-ti1 mt-[20px] text-gray01 dark:text-dark_gray01'}>
                    9. 변경내용의 고지와 동의요청
                </Text>
                <Text className={'mt-[10px]'}>
                    본 개인정보 처리방침은 시행일로부터 적용됩니다.
                    <br />
                    회사는 법령의 개정되거나 회사의 정책변경으로 본 처리방침 변경이 필요한 경우, 본 처리방침 중 추가,
                    삭제된 내용, 수정된 내용을 변경사항의 시행 7 일 전부터 웹사이트 또는 앱에서 게시되는 공지사항 또는
                    이메일, 문자 메시지 전송 등의 방법으로 통지할 것입니다.
                    <br />
                    그러나 개인정보의 수집 및 처리, 개인정보 위탁처리, 개인정보 제 3 자 제공, 개인정보의 국외이전 등과
                    같이 회원의 권리에 중요한 변경이 발생하는 경우 회사는 최소 30일 전에 회원에게 위와 같은 내용을
                    공지하고 변경된 내용의 동의를 요청합니다. 회원은 회사가 공지하거나 통지하는 개인정보 처리방침의
                    중대한 변경에 대해 동의를 거부할 권리를 보유하나, 변경된 사항의 동의를 거부하는 경우, 서비스 전체
                    또는 일부의 사용이 제한될 수 있습니다.
                </Text>
                <Text className={'mt-[10px]'}>
                    회사는 본 개인정보처리방침을 통해 회원들의 개인정보를 필요최소한의 범위 내에서 처리하고, 관계법령의
                    준수를 통해 회원들의 정보주체로서의 권익보호를 위해 노력하겠습니다.
                </Text>
                <Text className={'mt-[10px]'}>본 개인정보처리방침은 서비스 개시일로부터 발효됩니다.</Text>
                <Text className={'mt-[10px]'}>개인정보 처리방침 버전 번호 : 1.0.0</Text>
                <Text className={'mt-[10px]'}>· 개인정보처리방침 시행일자 : 2019 년 8 월 8 일</Text>
            </div>
        </>
    )
}
